<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header mb-3">
        <span class="col-auto">
          <h2 class="mb-0">Chargeback Aging Report</h2>
        </span>

        <div class="d-flex gap-3 align-items-center">
          <div class="col-auto">
            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportQuadReport1()"
              class="fullwdth secondary-btn" />
          </div>

          <span class="cross-border" (click)="onClose()"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <p-table
          #dt
          stripedRows
          [size]="'small'"
          scrollHeight="600px"
          [showCurrentPageReport]="true"
          [paginator]="false"
          responsiveLayout="scroll"
          [value]="qr1List"
          styleClass="table-listing popuptable"
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="qr1List.length >= 20"
          [autoLayout]="true"
          [resizableColumns]="true">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th
                class="text-center"
                style="width: 6rem"
                pSortableColumn="cbDays">
                CB Days
                <p-sortIcon field="cbDays"></p-sortIcon>
              </th>
              <th class="text-center">Invoice</th>
              <th class="text-center">Invoice Date</th>
              <th class="text-center">Client</th>
              <th class="text-center">Job Name</th>
              <th class="text-center">Total Amt</th>
              <th class="text-center">Open Amt</th>
              <th class="text-center">Email</th>
              <th class="text-center">Payments</th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="invoice"
                    id="invoice"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'invoice',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="client"
                    id="client"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'client',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="jobName"
                    id="jobName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'jobName',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="totalAmount"
                    id="totalAmount"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'totalAmount',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="openAmount"
                    id="openAmount"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'openAmount',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-qr1List let-rowIndex="rowIndex">
            <tr>
              <td>{{ qr1List.cbDays }}</td>
              <td>
                <a
                  class="link"
                  (click)="
                    getProjectInvoiceReport(
                      qr1List.invoice,
                      qr1List.invoiceDate
                    )
                  "
                  >{{ qr1List.invoice }}</a
                >
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    getProjectInvoiceReport(
                      qr1List.invoice,
                      qr1List.invoiceDate
                    )
                  "
                  >{{ qr1List.invoiceDate | date: "MM-dd-yyyy" }}</a
                >
              </td>
              <td>
                <a
                  class="link"
                  (click)="redirectToClientSummary(qr1List.clientId)"
                  >{{ qr1List.client }}</a
                >
              </td>
              <td>
                <a class="link" (click)="redirectToSummary(qr1List.salesId)">{{
                  qr1List.jobName
                }}</a>
              </td>
              <td class="align-right">
                {{ qr1List.totalAmount | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ qr1List.openAmount | number: "1.2-2" }}
              </td>
              <td class="align-items-center">
                <a
                  class="text-center p-0 me-2 task"
                  style="text-decoration: none"
                  [title]="'Email'"
                  [href]="setEmailData(qr1List)">
                  <i class="pi pi-envelope"></i>
                </a>
              </td>
              <td class="align-right">
                {{ qr1List.payments | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
